import "./ResourceVisibleCell.css";

import AddBoxIcon from "@mui/icons-material/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";

const ResourceVisibleCell = ({ rowObj, funcs }) => {
	let icon;
	let title = "";

	if (rowObj.model_name) {
		icon = rowObj.resourcesVisibility ? <IndeterminateCheckBoxOutlinedIcon /> : <AddBoxIcon />;
		title = rowObj.resourcesVisibility ? "Скрыть" : "Отобразить";
	}

	return (
		<td key={rowObj.key} className="TableCell" clm="show_fsnb_resource" treecell={"false"} title={title}>
			<div className="TreeActionCell" title="Показать состав нормы" onClick={() => funcs.changeNormContentVisible(rowObj, "resources")}>
				{icon}
			</div>
		</td>
	);
};

export default ResourceVisibleCell;
